export const ceoStatusReducer = (state = {}, action) => {
    switch (action.type) {
        case "UPDATECEOSTATUS":
            return {
                ...state,
                isDeleted: action.payload.isDeleted,
                canceledPremium: action.payload.canceledPremium
            }
        default:
            return state;
    }
};

export default ceoStatusReducer;